import React from 'react';
import { createContainer } from 'unstated-next';

function useModalState() {
  const initialState = {
    modalType: null,
    modalProps: null,
  };

  const [modal, setModal] = React.useState(initialState);
  const isModalOpen = (modalType) => modal.modalType === modalType;

  return {
    modalType: modal.modalType,
    modalProps: modal.modalProps,
    openModal: (modalProps) => setModal(modalProps),
    closeModal: () => setModal(initialState),
    isModalOpen: (modalType) => isModalOpen(modalType),
  };
}

const Modal = createContainer(useModalState);

export const ModalProvider = Modal.Provider;
export const useModal = Modal.useContainer;
